export const FileCategory = {
    BLOG: 1,
};